import { useEffect, useState } from "react";

export type AppConfig = {
  currency: string;
  country: string;
  countryCode: string;
  /** Days a listing stays up before it needs renewing (bumping renews it too). */
  listingDays: number;
  /** Phone-number sign-in; off until an SMS provider is set up. */
  phoneSignIn: boolean;
  /** WhatsApp Business number for support (+9665…), or null when none is set. */
  supportWhatsapp: string | null;
};

const DEFAULTS: AppConfig = { currency: "SAR", country: "SA", countryCode: "+966", listingDays: 30, phoneSignIn: true, supportWhatsapp: null };
let cache: AppConfig | null = null;
let pending: Promise<AppConfig> | null = null;

function load(): Promise<AppConfig> {
  pending ??= fetch("/api/config")
    .then((r) => (r.ok ? r.json() : DEFAULTS))
    .catch(() => DEFAULTS)
    .then((c: AppConfig) => (cache = { ...DEFAULTS, ...c }));
  return pending;
}

/** Market settings (currency, country) from the server; defaults to Saudi Arabia until loaded. */
export function useAppConfig(): AppConfig {
  const [cfg, setCfg] = useState<AppConfig>(cache ?? DEFAULTS);
  useEffect(() => {
    if (!cache) load().then(setCfg);
  }, []);
  return cfg;
}
